import { Descriptions } from 'antd';
import styled from 'styled-components';

export const FaqDescriptions = styled(Descriptions)`
  .ant-descriptions-item {
    padding: 0;
  }
`;
